module.exports = __webpack_public_path__ + "media/components/src/assets/images/what_day/medal-fba22d7c034e3e16009787e806fc7616.png";